import axios from 'axios'
import { destroyUserInfo, setCookie, getCookie } from './Auth'


export const setHttpErrObj = (errFunc, message, stacktrace) => {
    const date = new Date();
    const { name, email } = getCookie('contextInfo') ? JSON.parse(getCookie('contextInfo')) : {}
    const errorObj = {
        "@timestamp": date.toISOString(),
        "level": "error",
        "user": name || '',
        "email": email || '',
        "app": window._env_.APP_NAME,
        "page": window.location.pathname,
        "function": errFunc,
        "message": message,
        "stacktrace": stacktrace
    }
    return errorObj
}

export const getHttpClient = function (keycloak, url, headers = {}) {
    return fetch(url, {
        method: 'GET',
        headers,
    }).then((response) => {
        if (window.location.pathname !== '/portal/error') {
            if (response.status === 401) {
                destroyUserInfo()
                keycloak.logout()
            } else if (response.status >= 500) {
                const errorObj = setHttpErrObj("getHttpClient", "status bad request", "HTTP Client GET: status bad request " + response.url)
                setCookie('error', JSON.stringify(errorObj), { period: 'minutes', duration: 1 })
                window.location.href = `/portal/error?errorCode=${response.status}&message=error_text_1&setLog=true`
            } else {
                return response.json()
            }
        }
    }).then((responseJson) => {
        return responseJson
    }).catch(err => console.error('HTTP Client GET', err))
}

export const postHttpClient = function (keycloak, url, headers = {}, body = {}) {
    return fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
    }).then((response) => {
        if (window.location.pathname !== '/portal/error') {
            if (response.status === 401) {
                destroyUserInfo()
                keycloak.logout()
            } else if (response.status >= 500) {
                const errorObj = setHttpErrObj("postHttpClient", "status bad request", "HTTP Client POST: status bad request " + response.url)
                setCookie('error', JSON.stringify(errorObj), { period: 'minutes', duration: 1 })
                window.location.href = `/portal/error?errorCode=${response.status}&message=error_text_1&setLog=true`
            } else {
                return response.json()
            }
        }
    }).then((responseJson) => {
        return responseJson
    }).catch(err => console.error('HTTP Client POST', err))
}

export const putHttpClient = function (keycloak, url, headers = {}, body = {}) {
    return fetch(url, {
        method: 'PUT',
        headers,
        body: JSON.stringify(body)
    }).then((response) => {
        if (window.location.pathname !== '/portal/error') {
            if (response.status === 401) {
                destroyUserInfo()
                keycloak.logout()
            } else if (response.status >= 500) {
                const errorObj = setHttpErrObj("putHttpClient", "status bad request", "HTTP Client PUT: status bad request " + response.url)
                setCookie('error', JSON.stringify(errorObj), { period: 'minutes', duration: 1 })
                window.location.href = `/portal/error?errorCode=${response.status}&message=error_text_1&setLog=true`
            } else {
                return response.json()
            }
        }
    }).then((responseJson) => {
        return responseJson
    }).catch(err => console.error('HTTP Client PUT', err))
}

export const patchHttpClient = function (keycloak, url, headers = {}, body = {}) {
    return fetch(url, {
        method: 'PATCH',
        headers,
        body: JSON.stringify(body)
    }).then((response) => {
        if (window.location.pathname !== '/portal/error') {
            if (response.status === 401) {
                destroyUserInfo()
                keycloak.logout()
            } else if (response.status >= 500) {
                const errorObj = setHttpErrObj("patchHttpClient", "status bad request", "HTTP Client PATCH: status bad request " + response.url)
                setCookie('error', JSON.stringify(errorObj), { period: 'minutes', duration: 1 })
                window.location.href = `/portal/error?errorCode=${response.status}&message=error_text_1&setLog=true`
            } else {
                return response.json()
            }
        }
    }).then((responseJson) => {
        return responseJson
    }).catch(err => console.error('HTTP Client PATCH', err))
}

export const deleteHttpClient = function (keycloak, url, headers = {}) {
    return fetch(url, {
        method: 'DELETE',
        headers,
    }).then((response) => {
        if (window.location.pathname !== '/portal/error') {
            if (response.status === 401) {
                destroyUserInfo()
                keycloak.logout()
            } else if (response.status >= 500) {
                const errorObj = setHttpErrObj("deleteHttpClient", "status bad request", "HTTP Client DELETE: status bad request " + response.url)
                setCookie('error', JSON.stringify(errorObj), { period: 'minutes', duration: 1 })
                window.location.href = `/portal/error?errorCode=${response.status}&message=error_text_1&setLog=true`
            } else {
                return response
            }
        }
    }).then((responseJson) => {
        return responseJson
    }).catch(err => console.error('HTTP Client DELETE', err))
}

export const getHttpVtoken = function (keycloak, url, headers = {}) {
    return fetch(url, {
        method: 'GET',
        headers,
    }).then((response) => {
        if (window.location.pathname !== '/portal/error') {
            if (response.status === 401) {
                destroyUserInfo()
                keycloak.logout()
            } else if (response.status === 404) {
                const errorObj = setHttpErrObj("getHttpVtoken", "User Not Found", "HTTP Client GET: status not found " + response.url)
                setCookie('error', JSON.stringify(errorObj), { period: 'minutes', duration: 1 })
                window.location.href = `/portal/error?errorCode=${response.status}&message=error_text_1&setLog=true`
            } else if (response.status >= 500) {
                const errorObj = setHttpErrObj("getHttpVtoken", "status bad request", "HTTP Client POST: status bad request " + response.url)
                setCookie('error', JSON.stringify(errorObj), { period: 'minutes', duration: 1 })
                window.location.href = `/portal/error?errorCode=${response.status}&message=error_text_1&setLog=true`
            } else {
                return response.json()
            }
        }
    }).then((responseJson) => {
        return responseJson
    }).catch(err => console.error('HTTP Client GET', err))
}

export const putHttpLog = (body = {}) => {
    return new Promise((resolve, reject) => {
        fetch(window._env_.LOG_URL, {
            method: 'PUT',
            body: JSON.stringify(body)
        }).then((response) => {
            return response.json()
        }).then((json) => {
            resolve(json);
        }).catch(error => {
            console.error('HTTP LOG', error)
            reject(error.message);
        })
    })
}


export const formDataHeader = () => {
    let config = {
        headers: {
            'content-type': 'multipart/form-data',
        }
    }
    return config
}

export const sendemailHttpClient = function (url, body, ran) {
    return axios.post(url, body, formDataHeader()).then((response) => {
        return response
    }).then((responseJson) => {
        return responseJson
    }).catch(err => console.error('HTTP Client POST', err))
}